module.exports = __webpack_public_path__ + "img/example6.a30dc39b.png";